import type { ComponentType, SVGProps } from "react";
import { cn } from "../../lib/utils";

export type SolarIconType = ComponentType<SVGProps<SVGSVGElement>>;

const iconSizeClasses = {
  xs: "size-3", // 12px
  sm: "size-4", // 16px
  md: "size-5", // 20px
  lg: "size-6", // 24px
  xl: "size-8", // 32px
  "2xl": "size-10", // 40px
  "3xl": "size-12", // 48px
} as const;

export type IconSize = keyof typeof iconSizeClasses;

export interface IconProps extends Omit<SVGProps<SVGSVGElement>, "children"> {
  icon: SolarIconType;
  size?: IconSize;
  decorative?: boolean;
}

export function Icon({
  icon: IconComponent,
  size = "md",
  className,
  decorative = true,
  "aria-label": ariaLabel,
  ...props
}: IconProps) {
  return (
    <IconComponent
      className={cn("inline-block shrink-0", iconSizeClasses[size], className)}
      aria-hidden={decorative ? "true" : undefined}
      aria-label={!decorative ? ariaLabel : undefined}
      role={!decorative ? "img" : undefined}
      {...props}
    />
  );
}
